export default "__VITE_ASSET__BBoukFBW__"